import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import SnowflakeIcon from 'assets/svgr-icons/Snowflake.svg'
import { useFrameExtraction } from './useFrameExtraction'

export const FrameExtractButton = () => {
  const { handleExtractFrame, isButtonDisabled } = useFrameExtraction()

  return (
    <ActionButton
      icon={<SnowflakeIcon />}
      tooltipText={translate(T.FREEZE_FRAME_LABEL)}
      onClick={handleExtractFrame}
      disabled={isButtonDisabled}
    />
  )
}
